import axios from 'axios'
import {
  LoginUpdate
} from './index'
import {
  Toast
} from "vant";
import router from '../router'

const service = axios.create({
  // baseURL: process.env.NODE_ENV === 'development' ? '/api2' : process.env.VUE_APP_BASE_URL,
  baseURL: process.env.VUE_APP_BASE_URL,
  // baseURL: "https://www.duobihouse.com",
  timeout: 60000
})
service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
service.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest'

// 请求拦截
service.interceptors.request.use(config => {
  config.headers.Authorization = 'Bearer ' + localStorage.getItem('WORK_ATOKEN');
  // console.log("请求拦截", config);
  return config
}, error => {
  console.log('请求err：', error)
  Promise.reject(error)
})

// 响应拦截
service.interceptors.response.use(response => {
  // console.log('响应拦截', response)
  // 统一处理
  if (response.data.isSuccess === 1) return response.data
  //抛出异常，进入axios的catch
  Toast.fail(response.data.message || '发生异常')
  return Promise.reject(response.data)
}, error => {
  console.log('拦截err：', error) // for debug
  handleCode(error.response)
  return Promise.reject(error)
})

// 状态码处理
function handleCode(res) {
  switch (res.status) {
    case 401:
      // 授权过期
      if (res.data == 'expired') {
        let obj = {
          accessToken: localStorage.getItem('WORK_ATOKEN'),
          refreshToken: localStorage.getItem('WORK_RTOKEN'),
        }
        LoginUpdate(obj).then(resData => {
          // console.log('重新获取token', resData);
          localStorage.setItem("WORK_ATOKEN", resData.data[0].accessToken);
          localStorage.setItem("WORK_RTOKEN", resData.data[0].refreshToken);
          Toast.loading({
            message: '授权过期，重新加载...',
            onClose: () => {
              location.reload()
            }
          })
        }).catch(err => {
          Toast.fail({
            message: '服务器异常，请重新登录！',
            onClose: () => {
              loginOut()
            }
          })
        })
        return
      }
      //   未登录
      if (res.data == "token can't be empty") {
        noToken()
        return
      }
      // 其他错误
      Toast.fail({
        message: res.data || '授权验证有误，请重新登录！',
        onClose: () => {
          loginOut()
        }
      })
      break;
    default:
      Toast.fail('服务器异常')
      break;
  }
}

function loginOut() {
  if (localStorage.getItem('WORK_ATOKEN')) {
    // console.log('401', router.history.current);
    localStorage.removeItem("WORK_ATOKEN");
    localStorage.removeItem("WORK_RTOKEN");
    router.replace("/workLogin")
  }
}
// 实际只有第一个接口进行到这
function noToken() {
  localStorage.removeItem("WORK_ATOKEN");
  localStorage.removeItem("WORK_RTOKEN");
  router.replace("/workLogin")
}

export default service